import React, {Component} from 'react'
import {observer, inject} from 'mobx-react'
import {withBoundary} from 'Components/ErrorBoundary'
import DocumentTitle from 'react-document-title'
import Settings from './Settings'
import Chart from './Chart'
import IBModal from 'Components/IBModal'

import style from './style.sass'

@withBoundary
@inject('store') @observer
class Analysis extends Component {
  componentDidMount() {
    this.props.store.analysis.getSupportedParts()
  }
  render() {
    return(
      <div styleName='wrapper'>
        <DocumentTitle title='Analysis'/>
        <IBModal/>
        <Settings/>
        <Chart/>
      </div>
    )
  }
}

export default Analysis
